'use client';

import { useTranslations } from '@/i18n/use-translations';
import logger from '@/utils/client-logger';
import { getSpmForAppLaunch } from '@/reporting/spm/spm-session';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import appStoreImage from './icon/app-store.png';
import googlePlayImage from './icon/google-play.png';

const DownloadApp = () => {
  const [toAppLink, setToAppLink] = useState('https://zeelool.onelink.me/QxSq/iw85lexv');
  const t = useTranslations('layout.footer');

  useEffect(() => {
    try {
      const pub_zl_utm_source =
        (window.parent as any).latestChannelAttribute?.expires > Date.now()
          ? (window.parent as any).latestChannelAttribute?.pub_zl_utm_source || undefined
          : undefined;
      const pub_zl_utm_medium =
        (window.parent as any).latestChannelAttribute?.expires > Date.now()
          ? (window.parent as any).latestChannelAttribute?.pub_zl_utm_medium || undefined
          : undefined;
      const pub_zl_utm_campaign =
        (window.parent as any).latestChannelAttribute?.expires > Date.now()
          ? (window.parent as any).latestChannelAttribute?.pub_zl_utm_campaign || undefined
          : undefined;
      const pub_zl_utm_campaignid =
        (window.parent as any).latestChannelAttribute?.expires > Date.now()
          ? (window.parent as any).latestChannelAttribute?.pub_zl_utm_campaignid || undefined
          : undefined;
      const pub_zl_referrer =
        (window.parent as any).latestChannelAttribute?.expires > Date.now()
          ? (window.parent as any).latestChannelAttribute?.pub_zl_referrer || undefined
          : undefined;
      const pub_zl_page =
        (window.parent as any).latestChannelAttribute?.expires > Date.now() ||
        (window.parent as any).latestChannelAttribute?.expires === -1
          ? (window.parent as any).latestChannelAttribute?.pub_zl_page || undefined
          : undefined;
      const url = new URL(toAppLink);
      pub_zl_utm_source && url.searchParams.set('pub_zl_utm_source', pub_zl_utm_source);
      pub_zl_utm_medium && url.searchParams.set('pub_zl_utm_medium', pub_zl_utm_medium);
      pub_zl_utm_campaign && url.searchParams.set('pub_zl_utm_campaign', pub_zl_utm_campaign);
      pub_zl_utm_campaignid && url.searchParams.set('pub_zl_utm_campaignid', pub_zl_utm_campaignid);
      pub_zl_referrer && url.searchParams.set('pub_zl_referrer', pub_zl_referrer);
      pub_zl_page && url.searchParams.set('pub_zl_page', pub_zl_page);
      // App refer 闭环（H5→原生）：OneLink 唤起透传 spm，无来源不拼。
      const spm = getSpmForAppLaunch();
      spm && !url.searchParams.has('spm') && url.searchParams.set('spm', spm);
      setToAppLink(url.toString());
    } catch (error) {
      logger.log('error', error);
    }
  }, []);

  return (
    <section className="flex w-full flex-col items-center justify-center gap-[12px] rounded-[6px] bg-[#282828] py-[20px]">
      <p className="text-center font-br text-[13px] font-normal leading-none text-primary-white">
        {t('downloadApp.title')} {t('downloadApp.saveMore')}
      </p>
      <div className="flex items-center justify-center gap-[12px]">
        <a href={toAppLink} aria-label="Download on the App Store">
          <Image
            className="h-[24px] w-[104px]"
            src={appStoreImage}
            alt={t('downloadApp.appStore')}
            width={104}
            height={24}
            unoptimized
          />
        </a>
        <a href={toAppLink} aria-label="Download on Google Play">
          <Image
            className="h-[24px] w-[104px]"
            src={googlePlayImage}
            alt={t('downloadApp.googlePlay')}
            width={104}
            height={24}
            unoptimized
          />
        </a>
      </div>
    </section>
  );
};

export default DownloadApp;
